import React from 'react'
import CommerceBoxMD from './CommerceBoxMD'
import * as T from './CommerceBox.types'
import PaypalPayLater from '@atoms/PaypalPayLater/PaypalPayLater'

const CommerceBoxLG = ({
  product,
  CTAButton,
  innerRef,
  isPDP = false,
  onAddToCart,
  onVariantChange,
  noPadding,
  WishlistButton,
  wishlistButtonOnRight,
  showLowestPrice
}: T.CommerceBoxLGProps) => {
  return (
    <>
      <CommerceBoxMD
        isPDP={isPDP}
        innerRef={innerRef}
        product={product}
        CTAButton={CTAButton}
        onAddToCart={onAddToCart}
        onVariantChange={onVariantChange}
        noPadding={noPadding}
        displayExtendedInfo={true}
        WishlistButton={WishlistButton}
        wishlistButtonOnRight={wishlistButtonOnRight}
        showLowestPrice={showLowestPrice}
      />
      {isPDP && product?.c_paypalPayLater && (
        <PaypalPayLater amount={product.price} type='pdp' isDarkMode={false} />
      )}
    </>
  )
}

export default CommerceBoxLG
